export default __webpack_public_path__ + "static/account-created~ViZDAjjf-97bfe1282cf71e88188a1e535e7732db.png";